import {Typography} from 'components/Typography';
import {FilterLink} from 'plugins/modules/filter/components/FilterLink';

import style from './style.module.scss';
import {useListingContext} from 'plugins/modules/listing/context';
import {IProductShort} from 'modules/products/types';

export const InterestingSections = () => {
    const {meta} = useListingContext<IProductShort>();

    const list = meta?.interestingSections;

    if (!list) {
        return null;
    }

    return (
        <div>
            <Typography className={style.title} variant={'ch-display-42-reg'}>
                Интересные разделы
            </Typography>
            <ul className={style.list}>
                {list.map(({title, url}) => {
                    return (
                        <li className={style.item} key={`${title}-${url}`}>
                            <FilterLink title={title} url={url} />
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};
